import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  AdvertiseListReq,
  AdvertiseListRes,
  CreateAdvertiseReq,
  ActionAdvertiseRes,
  UpdateAdvertiseReq,
  DeleteAdvertiseReq,
  AdvertiseDetailReq,
  AdvertiseDetailRes,
} from './types'

export const getAdvertiseListAction = createAsyncAction(
  'ADVERTISE/GET_ADVERTISE_LIST_REQ',
  'ADVERTISE/GET_ADVERTISE_LIST_SUCCESS',
  'ADVERTISE/GET_ADVERTISE_LIST_FAILURE',
)<AdvertiseListReq, AdvertiseListRes, Error>()

export const getAdvertiseDetailAction = createAsyncAction(
  'ADVERTISE/GET_ADVERTISE_DETAIL_REQ',
  'ADVERTISE/GET_ADVERTISE_DETAIL_SUCCESS',
  'ADVERTISE/GET_ADVERTISE_DETAIL_FAILURE',
)<AdvertiseDetailReq, AdvertiseDetailRes, Error>()

export const createAdvertiseAction = createAsyncAction(
  'ADVERTISE/CREATE_ADVERTISE_REQ',
  'ADVERTISE/CREATE_ADVERTISE_SUCCESS',
  'ADVERTISE/CREATE_ADVERTISE_FAILURE',
)<CreateAdvertiseReq, ActionAdvertiseRes, Error>()

export const updateAdvertiseAction = createAsyncAction(
  'ADVERTISE/UPDATE_ADVERTISE_REQ',
  'ADVERTISE/UPDATE_ADVERTISE_SUCCESS',
  'ADVERTISE/UPDATE_ADVERTISE_FAILURE',
)<UpdateAdvertiseReq, ActionAdvertiseRes, Error>()

export const deleteAdvertiseAction = createAsyncAction(
  'ADVERTISE/DELETE_ADVERTISE_REQ',
  'ADVERTISE/DELETE_ADVERTISE_SUCCESS',
  'ADVERTISE/DELETE_ADVERTISE_FAILURE',
)<DeleteAdvertiseReq, ActionAdvertiseRes, Error>()

export const clearEventAction = createStandardAction('ADVERTISE/CLEAR_EVENT')<void>()
